import {
    AutocompleteInput,
    DateInput,
    Edit,
    NumberInput,
    ReferenceInput,
    SelectInput,
    SimpleForm,
    TextInput,
} from "@/components/admin";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Briefcase, Calendar, User } from "lucide-react";
import { required } from "ra-core";
import { FilteredContactInput } from "../misc/FilteredContactInput";

export const ProjectEdit = () => {
    return (
        <Edit title="Edit Project">
            <SimpleForm className="max-w-5xl mx-auto space-y-6">
                {/* Project Identity */}
                <Card className="w-full shadow-sm">
                    <CardHeader className="pb-3 border-b bg-slate-50/50">
                        <div className="flex items-center gap-2">
                            <Briefcase className="w-5 h-5 text-slate-500" />
                            <CardTitle className="text-lg font-semibold tracking-tight">Project Information</CardTitle>
                        </div>
                    </CardHeader>
                    <CardContent className="pt-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <TextInput source="reference" label="Project No." validate={required()} className="w-full font-mono" />
                            <TextInput source="name" label="Project Name" validate={required()} className="w-full" />
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-4">
                            <SelectInput
                                source="project_type"
                                label="Project Type"
                                choices={[
                                    { id: 'new_order', name: 'New Order' },
                                    { id: 'repeat_order', name: 'Repeat Order' },
                                ]}
                                className="w-full"
                            />
                            <SelectInput
                                source="status"
                                label="Status"
                                validate={required()}
                                choices={[
                                    { id: 'active', name: 'Active' },
                                    { id: 'on_hold', name: 'On Hold' },
                                    { id: 'completed', name: 'Completed' },
                                    { id: 'cancelled', name: 'Cancelled' },
                                ]}
                                className="w-full"
                            />
                        </div>
                        <div className="mt-4">
                            <TextInput
                                source="description"
                                label="Project Description"
                                multiline
                                rows={3}
                                className="w-full"
                            />
                        </div>
                    </CardContent>
                </Card>

                {/* Stakeholders */}
                <Card className="w-full shadow-sm">
                    <CardHeader className="pb-3 border-b bg-slate-50/50">
                        <div className="flex items-center gap-2">
                            <User className="w-5 h-5 text-slate-500" />
                            <CardTitle className="text-lg font-semibold tracking-tight">Stakeholders</CardTitle>
                        </div>
                    </CardHeader>
                    <CardContent className="pt-6">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            <ReferenceInput source="company_id" reference="companies">
                                <AutocompleteInput label="Client Company" validate={required()} className="w-full" />
                            </ReferenceInput>
                            <FilteredContactInput label="Client Contact" className="w-full" />
                            <ReferenceInput source="project_manager" reference="sales">
                                <AutocompleteInput label="Project Manager" className="w-full" optionText={(record: any) => record ? `${record.first_name} ${record.last_name}` : ''} />
                            </ReferenceInput>
                        </div>
                    </CardContent>
                </Card>

                {/* Timeline & Budget */}
                <Card className="w-full shadow-sm border-t-4 border-t-slate-900">
                    <CardHeader className="pb-3 border-b">
                        <div className="flex items-center gap-2">
                            <Calendar className="w-5 h-5 text-slate-500" />
                            <CardTitle className="text-lg font-semibold tracking-tight">Timeline & Budget</CardTitle>
                        </div>
                    </CardHeader>
                    <CardContent className="pt-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <DateInput source="start_date" label="Start Date" validate={required()} />
                            <DateInput source="expected_completion" label="Expected Completion" />
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                            <NumberInput
                                source="estimated_value"
                                label="Estimated Value (₹)"
                                className="w-full"
                            />
                            <NumberInput
                                source="actual_value"
                                label="Actual Value (₹)"
                                className="w-full"
                            />
                        </div>
                        <div className="mt-4">
                            <DateInput source="actual_completion" label="Actual Completion Date" />
                        </div>
                    </CardContent>
                </Card>
            </SimpleForm>
        </Edit>
    );
};
